export default __webpack_public_path__ + "static/covid-comms-award-34b111beac3cca78c6d240fa5614665c.png";